<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{title}}
        </slot>
      </CCardHeader>
      <CCardBody>
        <Loading v-if="isLoading"></Loading>
        <div v-else>
          <CForm>
          <CRow>
            <CCol sm="12">
              <CRow>
                <CCol sm="3">
                  <CInput 
                    label="Freezer Owner Code" 
                    invalid-feedback="Freezer Owner Code should be filled" 
                    :readonly="true" 
                    v-model="$v.ownerForm.freezer_owner_code.$model" 
                    :is-valid="!$v.ownerForm.freezer_owner_code.$invalid"
                  />
                </CCol>
                <CCol sm="3">
                  <CInput 
                    label="Owner Name" 
                    invalid-feedback="Owner name should be filled" 
                    required 
                    v-model="$v.ownerForm.name.$model" 
                    :is-valid="!$v.ownerForm.name.$invalid"
                  />
                </CCol>
                <CCol sm="3">
                  <CInput 
                    label="Email" 
                    invalid-feedback="Email should be filled" 
                    required 
                    v-model="$v.ownerForm.email.$model" 
                    :is-valid="!$v.ownerForm.email.$invalid"
                  />
                </CCol>
                <CCol sm="3">
                  <div class="form-group">
                    <label for="status">Owner Status</label>
                    <model-select 
                      class="form-control" 
                      id="status" 
                      :options="ownerStatusList" 
                      v-model="$v.ownerForm.status.$model" 
                      :isError="$v.ownerForm.status.$invalid" 
                      placeholder="-- Harap pilih salah satu --">
                    </model-select>
                    <div 
                      v-if="$v.ownerForm.status.$invalid" 
                      class="invalid-feedback-custom">
                        Owner Status should be filled.
                    </div>
                  </div>
                </CCol>
              </CRow>
              <CRow>
                 <CCol sm="3">
                  <CInput 
                    label="Mobile Phone" 
                    invalid-feedback="Mobile Phone should be filled" 
                    required 
                    v-model="$v.ownerForm.mobile_phone.$model" 
                    :is-valid="!$v.ownerForm.mobile_phone.$invalid"
                  />
                </CCol>
                <CCol sm="3">
                  <CInput 
                    label="Phone Number" 
                    v-model="$v.ownerForm.phone.$model" 
                    :is-valid="!$v.ownerForm.phone.$invalid"
                  />
                </CCol>
                <CCol sm="3">
                  <CTextarea 
                    label="Address" 
                    invalid-feedback="Address should be filled" 
                    required 
                    v-model="$v.ownerForm.address.$model" 
                    :is-valid="!$v.ownerForm.address.$invalid"
                  />
                </CCol>
              </CRow>

              <CRow>
                <CCol sm=6>
                  <label for="nik">Description</label>
                  <quill-editor
                    style="height: 200px; margin-bottom: 70px"
                    :content="content"
                    :options="editorOption"
                    v-model="$v.ownerForm.description.$model"
                    @change="onEditorChange($event)"
                  >
                  </quill-editor>
                  <br />
                  <div
                    v-if="$v.ownerForm.description.$invalid"
                    class="invalid-feedback-custom"
                  >
                    Description harus di isi.
                  </div>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </CForm>
        </div>
      </CCardBody>
      <CCardFooter align="right" :border-color="'white'">
        <CRow>
          <CCol sm="12">
            <CButton color="danger" title="Edit" size="sm" class="text-center" @click="back">
              <i class="fa fa-undo"></i> Back
            </CButton>&nbsp;
            <CButton
              color="success"
              :disabled="$v.ownerForm.$invalid"
              title="Detail"
              size="sm"
              @click="save"
            >
              <i class="fa fa-edit" /> Save
            </CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>

    <CCard>
      <CCardBody>
        <CTabs :active-tab.sync="activeTab">
          <CTab active>
            <template slot="title">Coverage</template>
            <br />
            <OwnerCoverage :owner="ownerForm" :provinceList="provinceList" :ownerCoverage="ownerCoverageList"></OwnerCoverage>
          </CTab>
        </CTabs>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import GlobalTable from "@/templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "@/templates/Loading";
import { required } from "vuelidate/lib/validators";

import OwnerCoverage from "./tabs/OwnerCoverage";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "OwnerFreezerDetail",
  components: { GlobalTable, Loading, quillEditor, OwnerCoverage},
  data() {
    return {
      title: "Owner Freezer Detail",
      ownerCoverageList: [],
      enableGeneratePassword: true,
      ownerForm: tableInterfaces.freezer_owner,
      isLoading: false,
      noParent: false,
      activeTab: 0,
      provinceList: [],
      paymentMethodList: [],
      customerCoverageList:[],
      deliveryMethodList:[],
      childofList:[],
      editorOption: {}, // data quill
      content:'',
      ownerStatusList: [],
      //enableAddPrice: true,
    };
  },
  validations: {
    ownerForm: {
      freezer_owner_code: {required},
      name: { required },
      email: { required },
      mobile_phone: { required },
      phone: {},
      address: { required },
      description: {},
      status: {required},
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function (id) {
      this.getOwnerDetail(id);
      this.getProvinceList();
      this.getOwnerCoverage(id);
      this.getStatusFreezerOwner();
    },
     back: function () {
      this.$router.go(-1);
    },
    resetForm: function () {
      for (var i in tableInterfaces.freezer_owner) {
        tableInterfaces.freezer_owner[i] = null;
      }
      this.ownerForm = tableInterfaces.freezer_owner;
    },
    getOwnerDetail: function (id) {
      this.isLoading = true;
      this.resetForm();
      this.axios
        .get("console/freezer_owner/detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.ownerForm = response.data.data;
            // console.log(response.data.data)

            // alert(this.agentForm);
            // this.agentForm.agent_code = response.data.data.agent_code;

            // console.log('this done?')
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    save: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah Data ini ?")) {
        this.isLoading = true;
        this.axios
          .put("console/freezer_owner/update", this.ownerForm)
          .then((response) => {
            this.showInfoNotification({
              title: "Ubah Owner",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Ubah Owner");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    getOwnerCoverage: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/freezer_owner/owner_coverage/listing/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.ownerCoverageList = response.data.data;
            
            // this.showInfoNotification({
            //   title: this.title,
            //   message: response.data.message,
            // });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getProvinceList: function(){
      this.axios.get("console/dropdown/province").then((response) => {
        this.provinceList = response.data.data;
      });
    },
     getStatusFreezerOwner: function(){
      this.axios.get("console/dropdown/freezer_owner_status").then((response) => {
        this.ownerStatusList = response.data.data;
      });
    },
    onEditorChange({ quill, html, text }) {
      this.content = html;
      this.ownerForm.description = html;
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
.ql-disabled .ql-editor{
  background-color:#d8dbe0;
}
</style>